import { i18n as I18n } from './i18n';

// `returnType` comes off the router query, so it can be absent or repeated;
// the template stringifies it either way, as it always has.
export const goBackText = (returnType?: string | string[]) => {
  return I18n.t(`back_buttons.${returnType}`);
};

export const scrollIntoViewWithOffset = (selector: string, offset: number) => {
  window.scrollTo({
    top:
      document.querySelector(selector)!.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      offset,
  });
};
